import type {z} from "zod";

import {UpdateUserBody} from "@project/sdk/admin/zod";

export const updateUserNameSchema = UpdateUserBody.shape.name
  .unwrap()
  .min(1, "Name cannot be empty if provided");
export const updateUserEmailSchema = UpdateUserBody.shape.email
  .unwrap()
  .min(1, "Email cannot be empty if provided");

export const updateUserRichSchema = UpdateUserBody.extend({
  name: updateUserNameSchema.optional(),
  email: updateUserEmailSchema.optional(),
});
export type UpdateUserFormPayload = z.infer<typeof updateUserRichSchema>;
